// @ts-strict-ignore
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { OnlinecodeService } from '../api/owcc/services';

/**
 * Interceptor to prevent parallel online code requests.
 */
@Injectable()
export class OnlineCodeInterceptor implements HttpInterceptor {
  private isOnlineCodeRequestInProgress = false;
  private readonly subject: Subject<HttpEvent<unknown>> = new Subject<HttpEvent<unknown>>();

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isOnlineCodeRequest = (req: HttpRequest<unknown>): boolean =>
      req.url.includes(OnlinecodeService.CreateOnlineCodePath.split('/').findLast(Boolean));

    if (!isOnlineCodeRequest(request)) {
      return next.handle(request);
    }

    if (this.isOnlineCodeRequestInProgress) {
      return this.subject.asObservable();
    }

    this.isOnlineCodeRequestInProgress = true;
    return next.handle(request).pipe(
      tap({
        next: (data: HttpResponse<unknown>) => {
          // no status for preflight request
          if (data.status) {
            this.isOnlineCodeRequestInProgress = false;
            this.subject.next(data);
          }
        },
        error: () => {
          this.isOnlineCodeRequestInProgress = false;
          this.subject.complete();
        }
      })
    );
  }
}
